document.addEventListener('DOMContentLoaded', () => {
  const subnFreeItem = document.querySelector('.wzg-subn-free-item');
  const productImage = document.querySelector('.wzg-free-product-img');
  const productTitle = document.querySelector('.wzg-product-title');
  const enlargedImg = document.getElementById('wzg-enlarged-img');

  function showEnlargedImage(e) {
    enlargedImg.style.display = 'block';
    moveEnlargedImage(e);
  }

  function moveEnlargedImage(e) {
    enlargedImg.style.left = `${e.pageX + 15}px`;
    enlargedImg.style.top = `${e.pageY + 15}px`;
  }

  function hideEnlargedImage() {
    enlargedImg.style.display = 'none';
  }

  function toggleEnlargedImage(e) {
    if (enlargedImg.style.display === 'block') {
      hideEnlargedImage();
    } else {
      showEnlargedImage(e);
    }
  }

  [productImage, productTitle].forEach(element => {
    element.addEventListener('mouseover', showEnlargedImage);
    element.addEventListener('mousemove', moveEnlargedImage);
    element.addEventListener('mouseout', hideEnlargedImage);
  });

  subnFreeItem.addEventListener('click', toggleEnlargedImage);
  subnFreeItem.addEventListener('mouseleave', hideEnlargedImage);
});
